var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "app-footer" }, [
      _c("div", { staticClass: "app-footer__inner" }, [
        _c("div", { staticClass: "app-footer-left" }, [
          _vm._v(" Powered by AndamiCompany Mono-Arch © 2023 "),
        ]),
        _c("div", { staticClass: "app-footer-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }